import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';

Injectable()
@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('token');

    if (!token) {
      return next.handle(req);
    }

    const cloned = req.clone({
      setParams: {
        'auth': token
      },
      headers: req.headers.set('Content-Type', 'application/x-www-form-urlencoded')
    });

    return next.handle(cloned);
  }
}
